module.exports = __webpack_public_path__ + "img/type-discovery.78eae328.png";